/**
 * Parses recipient identifiers from select values
 * @param {Array} recipients - Array of {value, label, accountName} objects
 * @param {boolean} forIndividuals - Whether recipients are individuals or groups
 * @returns {Object} - { playerIds, groupIds, subgroupIds, cohortIds }
 */
export const parseRecipients = (recipients, forIndividuals) => {
  if (forIndividuals) {
    return {
      playerIds: recipients.map(r => r.value),
      groupIds: [],
      subgroupIds: [],
      cohortIds: []
    };
  }

  const result = {
    playerIds: [],
    groupIds: [],
    subgroupIds: [],
    cohortIds: []
  };

  recipients.forEach(recipientObj => {
    const [type, id] = recipientObj.value.split('_');
    const parsedId = parseInt(id, 10);

    switch (type) {
      case 'cohort':
        result.cohortIds.push(parsedId);
        break;
      case 'group':
        result.groupIds.push(parsedId);
        break;
      case 'subgroup':
        result.subgroupIds.push(parsedId);
        break;
      default:
        console.warn(`Unknown recipient type: ${type}`);
    }
  });

  return result;
};
